"use strict";

var _interopRequireDefault = require("D:/work/dm/longda/web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.to-string.js");
var _regenerator2 = _interopRequireDefault(require("D:/work/dm/longda/web/node_modules/@babel/runtime/helpers/regenerator.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("D:/work/dm/longda/web/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _dictDetail = require("@/api/system/dictDetail");
var _default = exports.default = {
  data: function data() {
    return {
      dicts: [],
      dictobj: {}
    };
  },
  methods: {
    getDict: function getDict(name) {
      var _this = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              return _context.a(2, new Promise(function (resolve, reject) {
                (0, _dictDetail.get)(name).then(function (res) {
                  _this.dicts = res.data.page.data;
                  resolve(res);
                }).catch(function (err) {
                  reject(err);
                });
              }));
          }
        }, _callee);
      }))();
    },
    getDictObj: function getDictObj(names) {
      var _this2 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              return _context2.a(2, new Promise(function (resolve, reject) {
                (0, _dictDetail.getObj)(names).then(function (res) {
                  _this2.dictobj = res.data;
                  resolve(res);
                }).catch(function (err) {
                  reject(err);
                });
              }));
          }
        }, _callee2);
      }))();
    }
  }
};